export default "__VITE_ASSET__DWKyTYxN__"